<template>
  <div class="resource-create">
    <h2>{{ mode === 'edit' ? '자료 수정' : '자료 등록' }}</h2>
    <form @submit.prevent="submitResource">
      <div class="form-group">
        <label for="title">제목</label>
        <input type="text" id="title" v-model="form.title" required />
      </div>

      <div class="form-group">
        <label>내용</label>
        <ToastEditor v-model="form.content" />
      </div>

      <!-- 파일 업로드 -->
      <div class="form-group">
        <label for="files">파일 업로드</label>
        <input type="file" id="files" @change="handleFileUpload" multiple />
      </div>

      <!-- 파일 목록 (업로드된 파일 + 기존 파일) -->
      <div class="form-group" v-if="Object.keys(fileUrl).length">
        <label>첨부된 파일</label>
        <ul>
          <li v-for="(url, name) in fileUrl" :key="name">
            파일 이름: {{ name }}
            <button type="button" @click="removeFile(name)">x</button>
          </li>
        </ul>
      </div>

      <button type="submit">{{ mode === 'edit' ? '수정' : '등록' }}</button>
    </form>

    <router-link to="/admin" class="back">← 목록으로</router-link>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import ToastEditor from "@/components/ToastEditor.vue";
import axios from '@/utils/axios';

const route = useRoute();
const router = useRouter();
const form = ref({
  title: "",
  content: "",
});

const fileUrl = ref({}); // 파일 URL 목록 (파일명: 파일경로)
let selectedFiles = [];
const deletedFiles = ref([]); // 삭제된 파일 목록

// 📌 수정 모드에서는 파일 불러오기
const mode = ref(route.params.id ? 'edit' : 'create');
const resourceId = route.params.id;

onMounted(() => {
  if (mode.value === 'edit' && resourceId) {
    loadResource();
  }
});

// 📌 서버에서 자료 불러오기
const loadResource = () => {
  axios.get(`/bx201/resource/${resourceId}`)
    .then((response) => {
      const data = response.data;
      form.value.title = data.title;
      form.value.content = data.content;
      fileUrl.value = data.fileUrl || {}; // 파일 URL 받아오기
    })
    .catch(() => {
    });
};

// 파일 업로드 처리 (여러 번 선택해도 누적)
const handleFileUpload = (event) => {
  const newFiles = Array.from(event.target.files);

  // 기존 selectedFiles에 이미 있는 파일명은 중복 저장하지 않음 (optional)
  newFiles.forEach(file => {
    if (!selectedFiles.some(f => f.name === file.name && f.size === file.size)) {
      selectedFiles.push(file);
      fileUrl.value[file.name] = URL.createObjectURL(file); // 업로드 파일 미리보기
    }
  });
};

// 파일 제출 처리
const submitResource = () => {
  const formData = new FormData();
  formData.append("resource", new Blob([JSON.stringify({
    title: form.value.title,
    content: form.value.content,
  })], { type: 'application/json' }));

    // 삭제할 파일 정보 추가
    if (deletedFiles.value.length > 0) {
      formData.append("deletedFiles", JSON.stringify(deletedFiles.value));
    }

  // 새로 업로드된 파일 추가
  selectedFiles.forEach(file => formData.append("files", file));

  axios({
    method: mode.value === 'edit' ? 'put' : 'post',
    url: mode.value === 'edit'
      ? `/bx201/admin/resource/${resourceId}`   // 수정은 이 경로!
      : `/bx201/resource`,                      // 등록은 이 경로!
    data: formData
  })
  .then(() => {
    alert("자료 저장 완료!");
    loadResource(); // 저장 후 다시 불러와서 파일 목록 갱신
    router.push("/admin")
  })
  .catch();
};

// 파일 삭제 처리
const removeFile = (name) => {
  if (Object.prototype.hasOwnProperty.call(fileUrl.value, name)) {
    delete fileUrl.value[name];
    deletedFiles.value.push(name);
  }
};

</script>

<style scoped>
.resource-create {
  max-width: 800px;
  margin: 80px auto;
  padding: 0 16px;
}
form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.form-group {
  display: flex;
  flex-direction: column;
}
.form-group label {
  margin-bottom: 6px;
  font-weight: bold;
}
input[type="text"] {
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
}
button {
  padding: 12px;
  background: #111;
  color: white;
  font-weight: bold;
  border: none;
  cursor: pointer;
}
button:hover {
  background: #333;
}
.back {
  display: inline-block;
  margin-top: 24px;
  color: #007bff;
  text-decoration: none;
}
button[type="button"] {
  color: red;
  background: transparent;
  border: none;
  cursor: pointer;
}
button[type="button"]:hover {
  text-decoration: underline;
}
</style>
